import assistant from './assistant.json';
import checkout from './checkout.json';
import collection from './collection.json';
import colors from './colors.json';
import common from './common.json';
import courses from './courses.json';
import dashboard from './dashboard.json';
import empty from './empty.json';
import error from './error.json';
import filetypes from './filetypes.json';
import lernsets from './lernsets.json';
import login from './login.json';
import modals from './modals.json';
import onboarding from './onboarding.json';
import pricing from './pricing.json';
import profile from './profile.json';
import reader from './reader.json';
import schoolAdmin from './schoolAdmin.json';
import search from './search.json';
import sideBar from './sideBar.json';
import topBar from './topBar.json';
import trialReportCard from './trialReportCard.json';
import upgrade from './upgrade.json';
import upgradeBanner from './upgradeBanner.json';

export default Object.assign(
  {},
  assistant,
  checkout,
  collection,
  colors,
  common,
  dashboard,
  empty,
  error,
  filetypes,
  login,
  modals,
  profile,
  reader,
  search,
  topBar,
  upgrade,
  upgradeBanner,
  lernsets,
  courses,
  sideBar,
  pricing,
  onboarding,
  schoolAdmin,
  trialReportCard
);
